/** imported components

  * $ from jquery ===> component from jquery to use jquery for the page.
  * serviceProvider for ===> working with api
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * Helmet ===> for add specific title & CSS for the page.
  * Modal ===> component from material ui to use as popup

**/

import React, { useState, useEffect } from 'react';
import { Modal, Collapse, TextField } from '@material-ui/core'
import $ from "jquery";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import serviceProvider from '../../services/axios'
//AssignSectionPopup component start
export const AssignSectionPopup = (props) => {
    //defining variables here
    const [msAssignSearch, setMsAssignSearch] = useState('');
    const [invitedMember, setInvitedMember] = useState([]);
    const [isInvite, setIsInvite] = useState(false);
    const [multiEmailVal, setMultiEmailVal] = useState([]);
    const [singleEmail, setSingleEmail] = useState("");
    const [olduser, setOldUser] = useState([]);
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [selectedOwners, setSelectedOwners] = useState([]);
    const [classstatus, setClassstaus] = useState(false);
    var categoryid = props.catagory;
    if(!categoryid){
         categoryid=0;
    }
	const subcategoryid = props.subcatagory;
	const sectionName = props.sectionName;
	const plantid = props.pid;
    
    //Function to handle selected owners
    const HandleSelectedOwners = (val) => {
        console.log(val);
        let tmpArr = [...selectedOwners];
       
        if (tmpArr.indexOf(val.name) === -1) {
            tmpArr.unshift(val.name);
            setSelectedOwners(tmpArr);
            setOldUser(val.email);
           
        } else {
            let filterArr = tmpArr.filter((item, index) => {
                return item !== val.name;
            });
            setSelectedOwners(filterArr);
            setOldUser(val.email); 
        }
       
        
    }
    //Function to remove owner
    const RemoveOwner = (tmpIndex) => {
        let filterArr = selectedOwners.filter((item, index) => {
            return tmpIndex !== index;
        });
        setSelectedOwners(filterArr);
    }
    //Function to handle single email value
    const HandleSingleEmailValue = (e) => {
        let tmpValue = e.target.value;
        setSingleEmail(tmpValue);
    };
    //Function to add multiple email
    const AddMultiEmail = (e) => {
        
        let tmpArr =[];
        const emailRegx =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (e.key === "Enter" && emailRegx.test(String(singleEmail).toLowerCase()) && tmpArr.indexOf(singleEmail) === -1) {
            const addEmail = singleEmail;
            tmpArr.push(addEmail);
            setSingleEmail("");
            setMultiEmailVal(tmpArr);
        }
    };
    //Function to remove email
    const RemoveEmail = (e) => {
        let filterEmail = multiEmailVal.filter((item, index) => {
            return e !== index;
        });
        setMultiEmailVal(filterEmail);
    };
    //Function for close
    const handleClose = () => {
        props.setOpen(!props.open);
        setIsInvite(false);
    }
    //Function to handle value
    const HandleValue = (e) => {
        let val = e.target.value;
        setMsAssignSearch(val);
        let filterArr = invitedMember.filter((item, index) => {
            return item.name.toLowerCase().startsWith(val.toLowerCase());
        });
        if (val.length > 0) {
            setInvitedMember(filterArr);
        } else {
            setInvitedMember(invitedMember);
        }
    }
    const user = JSON.parse(localStorage.getItem("userData"));
    const usid = user ? user.uid : 0;
    //Function to handle invite
    const HandleInvite = () => {
        let username = props.tmpAssignUser;
        let name = multiEmailVal[0];
       
        let tmpObj = {
            ...props.assignedUsers,
            [username]:name
        };
        if (multiEmailVal != '') {
            setIsEmailSent(true);
            setTimeout(() => {
              setIsEmailSent(false);
              props.setAssignedUsers(tmpObj);
              handleClose();
            }, 2000)
      
      
            serviceProvider.post("/Businesscaseplantloss?type=send_member_invite", JSON.stringify({ email: name, uid: usid, invitation_category:categoryid,invited_sub_category:subcategoryid, role: 1, invitation_type:1, plants:plantid }),true).then((response) => {
             
            });
      
          }
 
   }
    //Function to handle assign
    const handleAssign = ()=>{
        let username = props.tmpAssignUser;
        let name = selectedOwners[0];
        console.log(name);
        
        if (olduser != '') {
            let tmpObj = {
                ...props.assignedUsers,
                [username]:name
            };
            setIsEmailSent(true);
            props.setAssignedUsers(tmpObj);
            setTimeout(() => {
              setIsEmailSent(false);
              handleClose();
            }, 2000)


      
            serviceProvider.post("/Businesscaseplantloss?type=send_member_invite", JSON.stringify({ email: olduser, uid: usid, teamName: selectedOwners[0], invitation_category:categoryid,invited_sub_category:subcategoryid, invitation_type:1, plants:plantid }),true).then((response) => {
              
            });
      
          }
         
        
        
    }
    //Function to load user list
    const loadUserList = async () => {
        const result = await serviceProvider.get(`/plants/PopUpUsers?user_id=${usid}`,true,{});
        const data = result.data
       
       
        if(data!=""){
        const options = data.map(d => ({
          "id": d.id,
          "name": d.name + " " + d.last_name,
          "circleName": d.name.charAt(0) + "" + d.last_name.charAt(0),
          "invited": [],
          "email" : d.email
        }));
    
   
        setInvitedMember(options);
    }
      };
    
      useEffect(() => {
       loadUserList();
      }, []);

    return (
        <>
            {/* css for styling page */}
            <Helmet>
                    <link rel="stylesheet" href={require('./loss-assing-popup.scss').default} />
            </Helmet>
            {/* Assessment assign modal start */}
            <Modal open={props.open}
                // onClose={handleClose}
                className="assessment-assign-popup">
                {/* Assign popup main wrapper start */}
                <div className="ms-assign-section-popup">
                     {/* Assign popup card divided into two sections
                        ms-assign-header
                        ms-assign-content 
                    */}
                    <div className="ms-assign-section-card">
                        {!isEmailSent ?
                            <>
                                {/* header section
                                    section-name
                                    close-btn
                                */}
                                <div className="ms-assign-header">
                                    <span>Assign team member to {sectionName}</span>
                                    <button className="close-btn" onClick={handleClose}>
                                        <img src={require('../../assets/img/maturity-dashboard/cancel-dark.svg').default} alt="X" />
                                    </button>
                                </div>
                                {/* end */}
                                {/* content section has two parts that will come conditional
                                    "ms-select-owner-div
                                    ms-invite-member-div
                                */}
                                <div className="ms-assign-content">
                                    {/* this section has been divided into four parts 
                                        search-box
                                        ms-invite-div
                                        contact-empty-div
                                        ms-assign-scroll-div
                                    */}
                                    <div className="ms-select-owner-div" style={{ display: isInvite ? 'none' : '' }}>
                                        <div className={`ms-assign-search-box ${msAssignSearch.length > 0 ? 'active' : ''}`}>
                                            <label className="ms-assign-search">
                                                <img src={require('../../assets/img/maturity-dashboard/ms-assign-search.svg').default} alt="true" />
                                                <input type="text" placeholder="Search.." onChange={(e) => HandleValue(e)} value={msAssignSearch} />
                                            </label>
                                        </div>
                                        {/* This section has list of invite members */}
                                        <div className="ms-invite-div">
                                            <p>Select Owners</p>
                                            <button className="btn-invite" onClick={() => { setIsInvite(true) }}>
                                                E-mail Invite
                                            </button>
                                        </div>
                                        {/* this section will appear when there is no memeber invited */}
                                        <div className="contact-empty-div" style={{ display: invitedMember.length > 0 ? 'none' : '' }}>
                                            <p>Your contact list is empty.</p>
                                            <p>Click on <span className="blue-link">Email Invite</span> to assign owners.</p>
                                        </div>
                                         {/* list of selected owners */}
                                        <div className="ms-assign-scroll-div">
                                            <div className="selected-member-ul" style={{ display: selectedOwners.length > 0 ? '' : 'none' }}>
                                                {selectedOwners.map((item, index) => <div className="selected-member-li">
                                                    <span>{item}</span>
                                                    <button className="remove-list" onClick={() => RemoveOwner(index)}>
                                                        <img src={require('../../assets/img/maturity-dashboard/email-list-cancel.svg').default} alt="X" />
                                                    </button>
                                                </div>)}
                                            </div>

                                            <div className="select-owner-text" style={{ display: selectedOwners.length > 0 ? '' : 'none' }}>
                                                Select Owners
                                            </div>
                                            <div className="ms-cir-list-wrapper">
                                                {invitedMember.map((item, index) => <div dataid={index} className={`ms-cir-li ${selectedOwners.indexOf(item.name) !== -1 && classstatus}`} onClick={(e) => HandleSelectedOwners(item)} key={index}>
                                                    <div className={`ms-cir-div cir-${item.name[0].toLocaleLowerCase()}`}>{item.circleName}</div>
                                                    <div className="ms-cir-name">
                                                        <span>{item.name} </span>
                                                    </div>
                                                    <img className="selected-icon" src={require('../../assets/img/maturity-dashboard/cir-select-chk.svg').default} />
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                    {/* end */}
                                    {/* This section has been divided into four main parts
                                        ms-assign-search-box
                                        ms-invite-div
                                        email-input-wrapper
                                        ms-assign-scroll-div
                                    */}
                                    <div className="ms-invite-member-div" style={{ display: !isInvite ? 'none' : '' }}>
                                        <div className={`ms-assign-search-box ${msAssignSearch.length > 0 ? 'active' : ''}`}>
                                            <label className="ms-assign-search">
                                                <img src={require('../../assets/img/maturity-dashboard/ms-assign-search.svg').default} alt="true" />
                                                <input type="text" placeholder="Search.." onChange={(e) => HandleValue(e)} value={msAssignSearch} />
                                            </label>
                                        </div>
                                        {/* This section has title */}
                                        <div className="ms-invite-div">
                                            <p>Email Invite</p>
                                        </div>
                                        {/* This section has entered email */}
                                        <div className="email-input-wrapper">
                                            <label className="label">
                                                <span className="input-title">Email</span>
                                                <input type="text" value={singleEmail} onChange={(e) => HandleSingleEmailValue(e)} onKeyPress={(e) => AddMultiEmail(e)} className="input-field" placeholder="Type e-mail address" />
                                            </label>
                                        </div>
                                        {/* list of selected members */}
                                        <div className="ms-assign-scroll-div">
                                            <div className="selected-member-ul">
                                                {multiEmailVal.map((item, index) => <div className="selected-member-li">
                                                    <span>{item}</span>
                                                    <button className="remove-list" onClick={() => RemoveEmail(index)}>
                                                        <img src={require('../../assets/img/maturity-dashboard/email-list-cancel.svg').default} alt="X" />
                                                    </button>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                    {/* end */}
                                </div>
                                {/* ms-assign-footer has two parts both contains two buttons and will come conditionally */}
                                <div className="ms-assign-footer">
                                    {!isInvite ?
                                        <>
                                            <button className="ms-assign-btn cancel" onClick={handleClose}>
                                                Cancel
                                            </button>
                                            <button className="ms-assign-btn blue" onClick={handleAssign}>
                                                Assign
                                            </button>
                                        </>
                                        :
                                        <>
                                            <button className="ms-assign-btn cancel" onClick={() => setIsInvite(false)}>
                                                Back
                                            </button>
                                            <button className="ms-assign-btn blue" onClick={() => HandleInvite()}>
                                                Send Invite
                                            </button>
                                        </>
                                    }

                                </div>
                            </>
                            :
                             // invite-succesful section start
                            <div className="invite-successful">
                                <img src={require('../../assets/img/maturity-dashboard/done-check.png').default} alt="invite successfully" />
                                <p>
                                    Email invite successfully sent!
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}

